export default {
  PLASTIC: 'PLASTIC',
  FIBER: 'FIBER'
};
